/**
 * NEXORA AI - Onboarding Test Page (Temporary for Screenshots)
 * Shows the 3 Premium steps in isolation for testing
 */

import React, { useState } from 'react';
import WelcomeStep from '../components/onboarding/WelcomeStep.jsx';
import CompanyStep from '../components/onboarding/CompanyStep.jsx';
import GoalsStep from '../components/onboarding/GoalsStep.jsx';
import ProgressBar from '../components/onboarding/ProgressBar';

export default function OnboardingTestPage() {
  const [currentStep, setCurrentStep] = useState(0);
  const [onboardingData, setOnboardingData] = useState({});
  
  const TOTAL_STEPS = 3;

  const handleStepData = (stepData) => {
    setOnboardingData({ ...onboardingData, ...stepData });
  };

  const nextStep = () => {
    if (currentStep < TOTAL_STEPS - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderStep = () => {
    const stepProps = {
      data: onboardingData,
      onNext: nextStep,
      onBack: prevStep,
      onData: handleStepData,
      currentStep,
      totalSteps: TOTAL_STEPS
    };

    switch (currentStep) {
      case 0:
        return <WelcomeStep {...stepProps} />;
      case 1:
        return <CompanyStep {...stepProps} />;
      case 2:
        return <GoalsStep {...stepProps} />;
      default:
        return <WelcomeStep {...stepProps} />;
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950">
      {/* Progress Bar (hidden on welcome screen) */}
      {currentStep > 0 && (
        <ProgressBar
          currentStep={currentStep}
          totalSteps={TOTAL_STEPS}
          onBack={prevStep}
        />
      )}
      
      {/* Add padding-top when progress bar is visible */}
      <div className={currentStep > 0 ? 'pt-20' : ''}>
        {renderStep()}
      </div>
    </div>
  );
}
